(function () {
  const styles = ['color: white', 'background: black', 'height: 40px', 'padding: 10px 20px', 'border-radius: 20px'].join(';');
  const message = 'VENENENGEL';
  console.log('%c%s', styles, message);

  window.VENENENGEL = window.VENENENGEL || {};

  VENENENGEL.a11y = function () {
    try {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        document.documentElement.classList.add('reduced-motion');
        window.VENENENGEL.reducedMotion = true;
      }
    } catch (err) {
      console.error('Error in VENENENGEL.a11y:', err);
    }
  };

  VENENENGEL.disableFocusAndHide = function ({ focusSelectors = [], containerSelectors = [] }) {
    try {
      if (!focusSelectors.length && !containerSelectors.length) {
        throw new Error('Provide at least one selector');
      }

      const focusQuery = focusSelectors.join(', ');
      const containerQuery = containerSelectors.join(', ');

      const disableFocus = el => {
        if (el.getAttribute('tabindex') !== '-1') {
          el.setAttribute('tabindex', '-1');
        }
      };

      const hideContainer = el => {
        if (el.getAttribute('aria-hidden') !== 'true') {
          el.setAttribute('aria-hidden', 'true');
        }
        if (el.getAttribute('role') !== 'presentation') {
          el.setAttribute('role', 'presentation');
        }
      };

      // Initial pass
      if (focusQuery) document.querySelectorAll(focusQuery).forEach(disableFocus);
      if (containerQuery) document.querySelectorAll(containerQuery).forEach(hideContainer);

      // Observer for dynamic changes
      const observer = new MutationObserver(mutations => {
        const toDisable = new Set();
        const toHide = new Set();

        mutations.forEach(m => {
          if (m.type === 'childList') {
            m.addedNodes.forEach(node => {
              if (!(node instanceof HTMLElement)) return;
              if (focusQuery && node.matches(focusQuery)) toDisable.add(node);
              if (focusQuery) node.querySelectorAll(focusQuery).forEach(el => toDisable.add(el));
              if (containerQuery && node.matches(containerQuery)) toHide.add(node);
              if (containerQuery) node.querySelectorAll(containerQuery).forEach(el => toHide.add(el));
            });
          } else if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
            const target = m.target;
            if (containerQuery && target.matches(containerQuery)) {
              toHide.add(target);
              if (focusQuery) target.querySelectorAll(focusQuery).forEach(el => toDisable.add(el));
            }
          }
        });

        toDisable.forEach(disableFocus);
        toHide.forEach(hideContainer);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });

      return observer;
    } catch (err) {
      console.error('Error in VENENENGEL.disableFocusAndHide:', err);
      return null;
    }
  };

  VENENENGEL.initA11yFocusHide = function (config) {
    try {
      if (!config || (!config.focusSelectors?.length && !config.containerSelectors?.length)) {
        console.warn('VENENENGEL: No valid selectors provided for A11y focus/hide');
        return;
      }

      // Store observer reference for potential cleanup
      const observer = VENENENGEL.disableFocusAndHide(config);
      if (observer) {
        window.VENENENGEL.a11yObserver = observer;
      }
    } catch (err) {
      console.error('Error in VENENENGEL.initA11yFocusHide:', err);
    }
  };

  VENENENGEL.handleVariantChange = function (variantId) {
    try {
      console.log('VENENENGEL: Variant changed:', variantId);
    } catch (err) {
      console.error('Error in VENENENGEL.handleVariantChange:', err);
    }
  };

  VENENENGEL.cleanProductName = function (name) {
    try {
      if (!name) return '';
      return name.replace(/venen engel/gi, '').trim();
    } catch (err) {
      console.error('Error in VENENENGEL.cleanProductName:', err);
      return '';
    }
  };

  VENENENGEL.calculateMaxHeight = function () {
    requestAnimationFrame(() => {
      try {
        const announcementBar = document.querySelector('[data-rbjs="announcement-bar"]');
        const header = document.querySelector('[data-rbjs="header"]');
        const totalHeight = (announcementBar?.offsetHeight || 0) + (header?.offsetHeight || 0);
        const maxHeight = window.innerHeight - totalHeight;
        document.documentElement.style.setProperty('--window-max-height', `${maxHeight}px`);
      } catch (err) {
        console.error('Error in VENENENGEL.calculateMaxHeight callback:', err);
      }
    });
  };

  VENENENGEL.initMaxHeightListener = function () {
    try {
      VENENENGEL.calculateMaxHeight();
      window.addEventListener('resize', VENENENGEL.calculateMaxHeight);

      let scrollTimeout;
      window.addEventListener('scroll', () => {
        if (!scrollTimeout) {
          scrollTimeout = setTimeout(() => {
            try {
              VENENENGEL.calculateMaxHeight();
            } catch (err) {
              console.error('Error in scroll handler:', err);
            } finally {
              scrollTimeout = null;
            }
          }, 100);
        }
      });
    } catch (err) {
      console.error('Error in VENENENGEL.initMaxHeightListener:', err);
    }
  };

  VENENENGEL.initFadeInUp = function () {
    try {
      if (window.VENENENGEL.reducedMotion) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            try {
              if (entry.isIntersecting) {
                const el = entry.target;
                const rect = el.getBoundingClientRect();
                const isHiddenVertically = rect.top < 0 || rect.bottom > window.innerHeight;

                if (isHiddenVertically) {
                  const delay = el.dataset.delay;
                  if (delay) el.style.transitionDelay = `${delay}ms`;
                }

                el.classList.add('visible');
                observer.unobserve(el);
              }
            } catch (err) {
              console.error('Error in IntersectionObserver callback:', err);
            }
          });
        },
        { threshold: 0.1 }
      );

      document.querySelectorAll('.fade-in-up').forEach((el) => observer.observe(el));
    } catch (err) {
      console.error('Error in VENENENGEL.initFadeInUp:', err);
    }
  };

  VENENENGEL.initVariantChangeListener = function () {
    try {
      document.addEventListener('DOMContentLoaded', () => {
        try {
          const productForm = document.querySelector('product-form');
          if (productForm) {
            productForm.addEventListener('change', (event) => {
              try {
                if (event.target.name === 'id') {
                  const variantId = event.target.value;
                  VENENENGEL.handleVariantChange(variantId);
                  window.dispatchEvent(new CustomEvent('VENENENGEL:variantChange', { detail: { variantId } }));
                }
              } catch (err) {
                console.error('Error in variantChange event handler:', err);
              }
            });
          }
        } catch (err) {
          console.error('Error in DOMContentLoaded handler:', err);
        }
      });
    } catch (err) {
      console.error('Error in VENENENGEL.initVariantChangeListener:', err);
    }
  };

  VENENENGEL.initUrlVariantSync = function () {
    try {
      const syncVariantWithForm = () => {
        try {
          const params = new URLSearchParams(window.location.search);
          const variantFromUrl = params.get('variant');
          const form = document.querySelector('form[data-type="add-to-cart-form"]');
          const idField = form?.querySelector('input[name="id"]');
          if (!idField || !variantFromUrl) return;

          if (idField.value !== variantFromUrl) {
            idField.value = variantFromUrl;
            VENENENGEL.handleVariantChange(variantFromUrl);
            window.dispatchEvent(new CustomEvent('VENENENGEL:variantChange', { detail: { variantId: variantFromUrl } }));
          }
        } catch (err) {
          console.error('Error in syncVariantWithForm:', err);
        }
      };

      window.addEventListener('popstate', syncVariantWithForm);

      ['pushState', 'replaceState'].forEach((method) => {
        const original = history[method];
        history[method] = function (...args) {
          const result = original.apply(this, args);
          syncVariantWithForm();
          return result;
        };
      });

      syncVariantWithForm();
    } catch (err) {
      console.error('Error in VENENENGEL.initUrlVariantSync:', err);
    }
  };

  VENENENGEL.initChatOpenFromHash = function () {
    try {
      const CHAT_HASH = '#venenengel-chat-open';
      let didInitHashOpen = false;

      const openChat = () => {
        window.dispatchEvent(new Event('flyweightchatopen'));
      };

      const maybeOpenChatFromHash = () => {
        try {
          if (didInitHashOpen) return;
          if (window.location.hash !== CHAT_HASH) return;

          didInitHashOpen = true;
          openChat();
        } catch (err) {
          console.error('Error in maybeOpenChatFromHash:', err);
        }
      };

      maybeOpenChatFromHash();
      window.addEventListener('hashchange', maybeOpenChatFromHash);
      document.addEventListener('click', (event) => {
        try {
          const anchor = event.target?.closest?.('a');
          if (!anchor) return;

          let hash;
          try {
            hash = new URL(anchor.href, window.location.href).hash;
          } catch (_) {
            hash = anchor.getAttribute('href');
          }

          if (hash !== CHAT_HASH) return;
          openChat();
        } catch (err) {
          console.error('Error in chat open click handler:', err);
        }
      });
    } catch (err) {
      console.error('Error in VENENENGEL.initChatOpenFromHash:', err);
    }
  };

  VENENENGEL.initCartChangeListener = function () {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
        window.dispatchEvent(new CustomEvent('VENENENGEL:cartChange', { detail: payload }));
      });
    } catch (err) {
      console.error('Error in VENENENGEL.initCartChangeListener:', err);
    }
  };

  // initialize all modules, each in its own try/catch
  try {
    VENENENGEL.a11y();
  } catch (e) {
    console.error('Failed to initialize a11y:', e);
  }
  try {
    VENENENGEL.initVariantChangeListener();
  } catch (e) {
    console.error('Failed to initVariantChangeListener:', e);
  }
  try {
    VENENENGEL.initMaxHeightListener();
  } catch (e) {
    console.error('Failed to initMaxHeightListener:', e);
  }
  try {
    VENENENGEL.initFadeInUp();
  } catch (e) {
    console.error('Failed to initFadeInUp:', e);
  }
  try {
    VENENENGEL.initUrlVariantSync();
  } catch (e) {
    console.error('Failed to initUrlVariantSync:', e);
  }
  try {
    VENENENGEL.initChatOpenFromHash();
  } catch (e) {
    console.error('Failed to initChatOpenFromHash:', e);
  }
  try {
    VENENENGEL.initCartChangeListener();
  } catch (e) {
    console.error('Failed to initCartChangeListener:', e);
  }
  try {
    // Initialize A11y focus/hide for third-party widgets
    VENENENGEL.initA11yFocusHide({
      focusSelectors: [],
      containerSelectors: [
        '#form-agent-helper',
        '.rb-reviews__section',
        '.rb-footer__survey'
      ]
    });
  } catch (e) {
    console.error('Failed to initA11yFocusHide:', e);
  }
})();
